import { useEffect, useState } from "react";
import { paymentService } from "../../../services/payment.service";
import { getApiErrorMessage } from "../../../utils/downloadExcel";
import "../../../styles/users.css";

function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN");
}

export default function SsdiPayments() {
  const [payments, setPayments] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await paymentService.listPayments();
        if (!cancelled) setPayments(res?.data?.payments || []);
      } catch (err) {
        if (!cancelled) setError(await getApiErrorMessage(err, "Failed to load payments."));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="page">
      <h2>Payments</h2>
      {error ? <p className="error-text">{error}</p> : null}
      {loading ? (
        <p className="muted">Loading…</p>
      ) : payments.length === 0 ? (
        <p className="muted">No payment records yet.</p>
      ) : (
        <div className="company-table-wrap">
          <table className="users-table">
            <thead>
              <tr>
                <th>Payment Date</th>
                <th>Company</th>
                <th>Plan</th>
                <th>Amount</th>
                <th>Payment ID</th>
                <th>Status</th>
                <th>Source</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((row) => (
                <tr key={row._id}>
                  <td>{formatDate(row.paidAt || row.createdAt)}</td>
                  <td>{row.companyId?.companyName || "—"}</td>
                  <td>{row.meta?.targetPlanName || row.meta?.tierId || "—"}</td>
                  <td>₹{Number(row.amount || 0).toLocaleString("en-IN")}</td>
                  <td>{row.razorpayPaymentId || "—"}</td>
                  <td>{row.status}</td>
                  <td>{row.paymentSource || "RAZORPAY"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
